import { Observable } from 'rxjs/Observable';

export interface IDisplayElement {
  id: string;
  fields: IDisplayField[];
  type: string;
}

export interface IDisplayField {
  name: string;
  label?: IDisplayLabel;
  values: IDisplayValue[];
  tooltip?: string;
  defaultValue?: string;
  valueDelimiter?: string;
  viewTemplate?: IViewTemplate;
  attributes?: Array<IDisplayAttribute>;
  classes?: Array<string>;
  displayConditions?: IDisplayCondition[];
  labelValueSeparator?: string;
  customTooltip?: IDisplayValue[];
}

export interface IDisplayLabel extends IDisplayValue {
  type: string;
}

export interface IViewTemplate {
  name: string;
  parameters: Array<string>;
}

export interface IDisplaySource {
  source?: string;
  sourceKey?: string;
  field?: string;
  keys?: IValueKeys;
}

export interface IDisplayAttribute {
  name: string;
  value: string;
}

export interface IDisplayValue extends IDisplaySource {
  viewTemplate?: IViewTemplate;
  classes?: Array<string>;
  displayedValue$: Observable<string>;
}

export interface IValueKeys {
  staticValue?: string;

  [key: string]: string | number;
}

export interface IDisplayCondition {
  source: IDisplayValue;
  operation: string;
  destination?: IDisplayConditionDestination;
}

export interface IDisplayConditionDestination extends IDisplaySource {
  value?: any;
}
